import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular/standalone';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';

@Component({
  selector: 'app-add-user-dialog',
  templateUrl: './add-user.dialog.html',
  styleUrls: ['./add-user.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    MainDialogComponent,
  ],
})
export class AddUserDialogComponent {
  private formBuilder = inject(FormBuilder);
  private _modal = inject(ModalController);

  formGroup = this.formBuilder.group({
    name: ['', Validators.required],
    company: [''],
    role: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
  });

  save() {
    const value = this.formGroup.value;
    this._modal.dismiss(value);
  }

  dismiss() {
    this._modal.dismiss();
  }
}
